import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconNewspaper1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconNewspaper1"><Path d="M11.25 5.37695L2 3.31445V19.2888L11.25 21.3513V5.37695Z" fill="currentColor"/><Path d="M12.75 5.37695V21.3513L22 19.2888V3.31445L12.75 5.37695Z" fill="currentColor"/></CentralIconBase>;
});

export default IconNewspaper1;
